import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import PromBanner from "@/components/PromBanner";
import UpcomingEventsBanner from "@/components/UpcomingEventsBanner";

const BANNERS = [
  { id: "events", label: "Upcoming Events", Comp: UpcomingEventsBanner },
  { id: "prom", label: "Prom Night — Midnight at Memory Lane", Comp: PromBanner },
];

export default function TopBanners() {
  const [i, setI] = useState(0);
  const [shown, setShown] = useState(0);
  const [paused, setPaused] = useState(false);

  useEffect(() => {
    if (paused) return;
    const t = setInterval(() => setI((v) => (v + 1) % BANNERS.length), 9000);
    return () => clearInterval(t);
  }, [paused]);

  return (
    <div
      data-testid="top-banners"
      className="relative"
      onMouseEnter={() => setPaused(true)}
      onMouseLeave={() => setPaused(false)}
    >
      <div className="grid [&>*]:[grid-area:1/1]">
        {BANNERS.map(({ id, Comp }, idx) => {
          const active = idx === shown && idx === i;
          return (
            <motion.div
              key={id}
              data-testid={`top-banner-slide-${id}`}
              data-active={active ? "true" : "false"}
              initial={false}
              animate={{ opacity: active ? 1 : 0 }}
              transition={{ duration: 0.45 }}
              onAnimationComplete={() => { if (idx === shown && shown !== i) setShown(i); }}
              aria-hidden={!active}
              inert={!active}
              className={`h-full ${active ? "" : "pointer-events-none"}`}
            >
              <Comp topSlot />
            </motion.div>
          );
        })}
      </div>
      <div className="absolute bottom-3 left-1/2 -translate-x-1/2 flex items-center gap-2 z-10" data-testid="top-banners-dots">
        {BANNERS.map((b, idx) => (
          <button
            key={b.id}
            data-testid={`top-banner-dot-${b.id}`}
            aria-label={`Show ${b.label} banner`}
            aria-pressed={idx === i}
            onClick={() => setI(idx)}
            className={`h-2 rounded-full transition-all duration-300 ${idx === i ? "w-7 bg-gold" : "w-2 bg-foreground/30 hover:bg-foreground/60"}`}
          />
        ))}
      </div>
    </div>
  );
}
